import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  medium: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
}));
interface propsAvatar{
  image:string
  abrv: string
}
const AvatarImage = ({image,abrv }:propsAvatar) => {  
  const classes = useStyles();
  return (
  <>
  {
    image !== null ?
    <Avatar alt={`${abrv}`} src={`${image}`} className={classes.large} />:
    <Avatar className={classes.large}>{`${abrv}`}</Avatar>
    }
  </>
  )
}
export default AvatarImage